import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import imageWithMetaDataSchema from './imageWithMetadataSchema';
const fullscreenMediaBlockSchema = Joi.object({
  type: Joi.string().valid('fullscreenMediaBlock').required(),
  code: Joi.string().allow('', null),
  sectionHeader: Joi.string().allow('', null),
  backgroundColor: Joi.string().allow('', null),
  eyebrow: Joi.string().allow('', null),
  title: Joi.string().allow('', null),
  subtitle: Joi.string().allow('', null),
  ctaText: Joi.string().allow('', null),
  ctaLink: Joi.string().allow('', null),
  brandLogo: Joi.object(imageWithMetaDataSchema).allow('', null),
  labelType: Joi.string().valid('new', 'promotion', 'bestseller').allow(null, ''),
  buttonVariant: Joi.string().valid('outline', 'filled').allow(null),
  buttonColor: Joi.string().allow('', null),
  titleStyle: Joi.string().valid('default', 'italic').allow(null),
  image: mediaUrlSchema.allow(null),
  video: mediaUrlSchema.allow(null),
  variant: Joi.string().valid('centered', 'left', 'bottom').allow(null),
  fullWidth: Joi.boolean().allow(null),
  showCartButton: Joi.boolean().allow(null),
  products: Joi.array().items(Joi.object({
    id: Joi.number().required(),
    name: Joi.string().required()
  }).unknown(true)).allow(null).empty(true)
}).unknown(true);
export default fullscreenMediaBlockSchema;